<template>
    <div>
        <div v-if="!sourceOnly" class="form-group" v-bind:class="{ 'has-error': errors.has('eligibility') }">
            <label class="col-md-2 control-label">NRHP Status</label>
            <div class="col-md-2">
                <select name="eligibility" v-model="evaluation.eligibilityId" class="form-control" v-validate="'required'">
                    <option disabled value ="">Select a value</option>
                    <option v-for="eligibilityType in eligibilityTypeList" v-bind:value="eligibilityType.eligibilityId" :key="eligibilityType.eligibilityId">
                        {{eligibilityType.description}}
                    </option>
                </select>
                <span v-show="errors.has('eligibility')" class="has-error">Eligibility is required</span>
            </div>
            <div v-if="isEligible" class="col-md-4">
                <div class="checkbox checkbox-inline" style="padding-top:0px">
                    <input type="checkbox" :id="'isKeeper'" value="keeper" v-model="evaluation.isKeeperDetermined" />
                        <label :for="'isKeeper'">Eligible by NRHP Keeper</label>
                </div>
            </div>
        </div>
        <div v-if="!sourceOnly" class="form-group">
            <div disabled class="col-md-8">
                <div class="checkbox checkbox-inline">
                    <input type="checkbox" v-model="culturalResource.isListed" id="isListed"/>
                    <label for="isListed">Listed</label>
                </div>
                <div class="checkbox checkbox-inline">
                    <input type="checkbox" v-model="culturalResource.isLandmark" id="isLandmark"/>
                    <label for="isLandmark">Landmark</label>
                </div>
                <div class="checkbox checkbox-inline">
                    <input type="checkbox" v-model="culturalResource.isMonument" id="isMonument"/>
                    <label for="isMonument">Monument</label>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Source</label>
            <div class="col-md-3">
                <select name="concurred" v-model="evaluation.concurredId" class="form-control">
                    <option disabled value ="">Select a value</option>
                    <option v-for="concurredType in concurredList" v-bind:value="concurredType.concurredId" :key="concurredType.concurredId">
                        {{concurredType.description}}
                    </option>
                </select>
            </div>
        </div>
        <div v-if="isEligible && !sourceOnly">
            <div class="form-group" v-bind:class="{ 'has-error': errors.has('criteria_group') }">
                <label class="col-md-2 control-label">Criteria Met</label>
                <div disabled class="col-md-8">
                    <div class="checkbox checkbox-inline">
                        <input type="checkbox" v-model="evaluation.isEligibleA" v-bind:id="evaluation.evaluationSourceId+'eligA'" v-bind:value="evaluation.evaluationSourceId+'A'"
                        name="criteria_group" v-validate="isEligible ? 'required' : ''" />
                            <label v-bind:for="evaluation.evaluationSourceId+'eligA'">A</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                        <input name="criteria_group" type="checkbox" v-model="evaluation.isEligibleB" v-bind:id="evaluation.evaluationSourceId+'eligB'" v-bind:value="evaluation.evaluationSourceId+'B'" />
                            <label v-bind:for="evaluation.evaluationSourceId+'eligB'">B</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                        <input name="criteria_group" type="checkbox" v-model="evaluation.isEligibleC" v-bind:id="evaluation.evaluationSourceId+'eligC'" v-bind:value="evaluation.evaluationSourceId+'C'" />
                            <label v-bind:for="evaluation.evaluationSourceId+'eligC'">C</label>
                    </div>
                    <div class="checkbox checkbox-inline">
                        <input name="criteria_group" type="checkbox" v-model="evaluation.isEligibleD" v-bind:id="evaluation.evaluationSourceId+'eligD'" v-bind:value="evaluation.evaluationSourceId+'D'" />
                            <label v-bind:for="evaluation.evaluationSourceId+'eligD'">D</label>
                    </div>
                    <div>
                        <span v-show="errors.has('criteria_group')" class="has-error">Criteria is required</span>
                    </div>
                </div>
            </div>
            <div v-if="evaluation.isEligibleB" class="form-group" v-bind:class="{ 'has-error': errors.has('associatedPerson') }">
                <label class="col-md-2 control-label">Associated Person</label>
                <div  class="col-md-3">
                    <input name="associatedPerson" type="text" class="form-control" v-model="evaluation.associatedPerson" v-validate="evaluation.isEligibleB ? 'required' : '' "/>
                    <span v-show="errors.has('associatedPerson')" class="has-error">Associated Person is required</span>
                </div>
            </div>
            <!-- <div>
                <div class="form-group">
                    <label class="col-md-2 control-label">Contributing Component: </label>
                    <div class="col-md-2">
                        <span class="form-control">{{ evaluation.isContributing ? 'Contributing' : 'Not Contributing' }}</span>
                    </div>
                </div>
            </div> -->
            <!-- <div class="form-group" v-bind:class="{ 'has-error': errors.has('effect') }">
                <label class="col-md-2 control-label">Effect</label>
                <div class="col-md-2">
                    <select name="effect" class="form-control" v-model="evaluation.effectId" v-validate="isEligible()? 'required' : '' ">
                        <option disabled value="">Select a value</option>
                        <option v-for="effect in effectList" v-bind:value="effect.effectId" :key="effect.effectId">
                            {{effect.description}}
                        </option>
                    </select>
                    <span v-show="errors.has('effect')" class="has-error">Effect is required</span>
                </div>
            </div> -->
        </div>
        <div class="form-group" v-if="!sourceOnly" v-bind:class="{ 'has-error': errors.has('justification') }">
            <label class="col-md-2 control-label">Discuss Condition and Integrity</label>
            <div class="col-md-10">
                <textarea name="justification" class="form-control" v-model="evaluation.justification" style="width:750px" rows="6" v-validate="'required'" />
                <span v-show="errors.has('justification')" class="has-error">Condition and Integrity are required</span>
            </div>
        </div>
        <div class="form-group">
            <button class="col-md-2 btn btn-primary" v-on:click="saveForm()">Save Evaluation</button>
        </div>
    </div>  
</template>

<script>
import loggingService from '@/services/util/loggingService'
import evaluationService from '@/services/siteForm/evaluationService'
import culturalResourceService from '@/services/culturalResourceService'

export default {
    name: 'siteEligibilityForm',
    components: {
    },
    data: function () {
        return {
            isLoading: false,
            isDebug: false,
            eligibilityEnum: {},
            evaluationList: []
        }
    },
    computed: {
        eligibilityTypeList: function () {
            return evaluationService.EligibilityTypeList
        },
        effectList: function () {
            return evaluationService.EffectList
        },
        concurredList: function () {
            return evaluationService.ConcurredList
        },
        isEligible: function () {
            return this.evaluation.eligibilityId === evaluationService.EligibilityEnum.Eligible
        }
    },
    props: {
        evaluation: {},
        culturalResource: {},
        sourceOnly: {typeof: Boolean, default: false}
    },
    mounted () {
        this.log(`siteEligibilityForm mounted`)
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Eligibility Form', message)
        },
        saveForm () {
            //this.$validator.clean()
            this.$validator.validateAll().then(result => {
                if (result) {
                    evaluationService.saveProduction(this.$http, this.evaluation).then(result => {
                        var eligibility = evaluationService.EligibilityTypeList.find(x => { return x.eligibilityId === this.evaluation.eligibilityId })
                        this.evaluation.eligibilityDescription = eligibility ? eligibility.description : ''
                        var effect = evaluationService.EffectList.find(x => { return x.effectId === this.evaluation.effectId })
                        this.evaluation.effectDescription = effect ? effect.description : ''
                    })
                    //save cr
                    culturalResourceService.put(this.$http, this.culturalResource).then(response => {
                        this.$emit('eligibilitySaved')
                    })
                } else {
                    this.log('submit - invalid form')
                }
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// SiteEligibilityForm.vue?0a867278